<template>
  <!-- Work Section -->
  <section class="work-section pt-0 mb-0">
    <div class="container">
      <div class="row  aos" data-aos="fade-up">
        <div class="col-md-12">
          <div class="offer-paths card">
            <div class="offer-bg d-none d-md-block">
              <img src="@/assets/img/bg/dot-white-2.png" class="img-fluid" alt="bg">
            </div>
            <div class="card-body pb-0">

              <div class="row justify-content-center align-items-center">
                <div class="col-lg-6">
                  <div class="offers-person-image d-none d-lg-block">
                    <img src="@/assets/img/bg/open-work-1.png" alt="" class="img-fluid">
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="content">
                    <h2 class="mb-2">We Are Offering 14 Days Free Trial</h2>
                    <p class="fs-14"> Each service provider will have a listing that typically
                      includes a description of their services, pricing,
                      availability, and any special offers or packages.</p>
                  </div>
                  <div class="offers-btn">
                    <a href="#" class="btn btn-white">Try 14 Days Free Trial <i
                        class="ti ti-arrow-right"></i></a>
                  </div>
                </div>
              </div>
            </div>
          
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-heading aos" data-aos="fade-up">
            <h2>How It Works</h2>
            <p>Straightforward process designed to make your experience seamless and hassle-free.</p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 d-flex ">
          <div class="work-box card flex-fill aos" data-aos="fade-up">
            <div class="card-body">
              <div class="work-icon ">
                <span>
                  <img src="@/assets/img/icons/work-icon-hand.svg" alt="img">
                </span>
              </div>
              <h5>1. Search and Browse</h5>
              <p>Customers can browse or search for specific products or services using categories,
                filters, or search bars.</p>
              <h4>01</h4>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 d-flex">
          <div class="work-box flex-fill card aos" data-aos="fade-up">
            <div class="card-body">
              <div class="work-icon">
                <span>
                  <img src="@/assets/img/icons/find-icon.svg" alt="img">
                </span>
              </div>
              <h5>Add to Cart or Book Now</h5>
              <p>Customers can add items to their shopping cart. For services, they may select a
                service and proceed to book.</p>
              <h4>02</h4>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 d-flex">
          <div class="work-box card flex-fill aos" data-aos="fade-up">
            <div class="card-body">
              <div class="work-icon">
                <span>
                  <img src="@/assets/img/icons/place-icon.svg" alt="img">
                </span>
              </div>
              <h5>Order Fulfillment</h5>
              <p>The Customer fulfills the order by either providing the service to the buyer. </p>
              <h4>03</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Work Section -->

  <!-- Service Section -->
  <section class="service-section bg-white">
    <div class="service-bg d-none d-md-block">
      <img src="@/assets/img/bg/square-sm.png" class="img-fluid" alt="bg">
    </div>
    <div class="container">
      <div class="section-heading">
        <div class="row align-items-center">
          <div class="col-md-6 aos" data-aos="fade-up">
            <h2>Most Popular Services</h2>
            <p>Explore the greates our services. You won’t be disappointed</p>
          </div>
          <div class="col-md-6 text-md-end aos" data-aos="fade-up">
            <div class="owl-nav mynav1"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="owl-carousel popular-slider">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="item in indexpopularservice" :key="item.id">
                <div class="service-widget aos" data-aos="fade-up">
                  <div class="service-img">
                    <router-link to="/details/service-details">
                      <img class="img-fluid serv-img" alt="Service Image"
                        :src="require(`@/assets/img/providers/${item.image}`)">
                    </router-link>
                    <div class="fav-item">
                      <router-link to="/service-categories/categories"><span class="item-cat">{{ item.badge }}</span></router-link>
                      <a href="javascript:void(0)" class="fav-icon" @click="toggleSelected">
                        <i class="feather-heart"></i>
                      </a>
                    </div>
                    <div class="item-info">
                      <router-link to="/service-provider/providers"><span class="item-img"><img
                        :src="require(`@/assets/img/profiles/${item.avatar}`)" class="avatar"
                        alt="User"></span></router-link>
                    </div>
                  </div>
                  <div class="service-content text-start">
                    <h3 class="title">
                      <router-link to="/details/service-details">{{ item.title }}</router-link>
                    </h3>
                    <p><i class="feather-map-pin me-1"></i>{{item.country}}<span class="rate"><i
                          class="fas fa-star filled me-1"></i>4.9</span></p>
                    <div class="serv-info">
                      <h6>{{ item.offer }}<span class="old-price">{{ item.price }}</span></h6>
                      <router-link to="/details/service-details" class="btn btn-light">Book Now</router-link>
                    </div>
                  </div>
                </div>
              </Slide>
              <template #addons>
              <Navigation />
              </template>
            </Carousel>
          </div>
        </div>
        <div class="d-flex btn-sec justify-content-center aos" data-aos="fade-up">
          <router-link to="/service/search" class="btn btn-dark d-flex align-items-center">View All<i
              class="ti ti-arrow-right ms-1"></i></router-link>
        </div>
      </div>
    </div>
  </section>
  <!-- /Service Section -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexpopularservice from "@/assets/json/indexpopularservice.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      indexpopularservice: indexpopularservice,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  mounted() {
    document.querySelectorAll(".fav-icon").forEach(function (element) {
      element.addEventListener("click", function () {
        element.classList.toggle("selected");
      });
    });
  },
  methods: {
    toggleSelected(event) {
      const element = event.target;
      element.classList.toggle("selected");
    },
  },
};
</script>
